import { Component, Inject, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';

@Component({
  selector: 'app-confirm-approval-modal',
  templateUrl: './confirm-approval-modal.component.html',
  styleUrls: ['./confirm-approval-modal.component.scss']
})
export class ConfirmApprovalModalComponent {

  public data: any;
  endPoint: any;
  payload: any;
  approvalForm!: FormGroup;
  submitted =false;

  constructor(private fb: FormBuilder, private api: SevaProfileService, protected dialogRef: NbDialogRef<ConfirmApprovalModalComponent>) {
    this.data = this.dialogRef;
  }
  isCommentBoxShow =false
  ngOnInit() {
    this.endPoint = this.data.endPoint;
    this.payload = this.data.requestBody;
    this.isCommentBoxShow = this.data.isCommentBoxShow;
  
    this.initializeForm();
  }
  
  initializeForm() {
    const commentValidators = this.isCommentBoxShow ? [] : [Validators.required]; // Apply validation conditionally
    this.approvalForm = this.fb.group({
      comment: ['', commentValidators],
    });
  }
  
  approve() {
    if (!this.isCommentBoxShow && this.approvalForm.invalid) {
      this.submitted = true;
      this.approvalForm.markAllAsTouched(); // Highlight invalid fields
      return;
    }
  
    this.submitted = false;
  
    if (!this.isCommentBoxShow) {
      const comment = this.approvalForm.get('comment')?.value;
      this.payload.FinalRemarks = comment;
    }
  
    this.api.apiCall(this.endPoint, 'POST', this.payload).subscribe((response: any) => {
      if (response.Data) {
        this.dialogRef.close(true); // Pass true to indicate approval
      }
    });
  }
  

  cancel() {
    this.dialogRef.close(false); // Pass false to indicate cancellation
  }
}
